import {
  DevelopmentPathChangeSourceDto,
  DevelopmentPathChangeTypeDto,
  DevelopmentPathStepFieldDto,
  ResourceTypeDto,
  TaskStatusDto,
} from '@/api/generated';

import { MyProfileTranslation } from './myProfile.translation.en';

export const myProfileTranslation: MyProfileTranslation = {
  activities: {
    count: '{{count}} aktywności',
    documents: {
      adminSectionTitle: 'Materiały od administratora',
      adminSource: 'Od administratora',
      aiContext: 'Kontekst AI',
      aiContextTooltip: 'Gdy włączone, asystent czatu może korzystać z treści tego dokumentu.',
      deleteDialog: {
        cancel: 'Anuluj',
        confirm: 'Usuń dokument',
        message: 'Czy na pewno chcesz usunąć ten dokument? Tej operacji nie można cofnąć.',
        title: 'Usuń dokument',
      },
      dropzoneHintPrefix: 'Akceptowane: PDF, DOCX, XLSX · maks.',
      dropzoneLabel: 'Przeciągnij pliki lub kliknij, żeby wgrać',
      dropzoneMaxSize: '20 MB / plik',
      embeddingStatus: {
        available: '✓ Dostępny w czacie AI',
        enableHint: 'Gotowy — włącz Kontekst AI',
        failed: 'Błąd przetwarzania',
        noContent: 'Brak treści do AI',
        processing: 'Przetwarzanie…',
        unsupported: 'Nieobsługiwany format',
        willBeAvailable: 'Będzie dostępny po przetworzeniu',
      },
      reembed: 'Przetwórz ponownie',
      title: 'Dokumenty i wyniki',
    },
    empty: 'Brak aktywności',
    fields: {
      developmentProgram: 'PROGRAM ROZWOJOWY',
      editYear: 'ROK EDYCJI',
    },
    noAccess: 'Nie masz dostępu do tych aktywności',
    showing: 'Wyświetlono {{visible}} z {{total}}',
    showMore: 'Pokaż więcej',
    status: {
      completed: 'Zakończona',
      inProgress: 'W toku',
      planned: 'Zaplanowane',
    },
    tabs: {
      active: 'Aktywne',
      archived: 'Archiwalne',
    },
  },
  basicInfo: {
    actions: {
      downloadFlashcard: 'Pobierz Fiszkę',
    },
    elevated: {
      absenceStatus: 'Status absencji',
      activeEmployee: 'Aktywny pracownik w aktualnej strukturze organizacyjnej',
      additionalInfo: 'Dodatkowe informacje',
      age: 'Wiek',
      aiSummaryDisclaimer:
        'Podsumowanie wygenerowane automatycznie przez AI. Może zawierać błędy, pominięcia lub nie odzwierciedlać pełnego obrazu doświadczenia, kompetencji i potencjału pracownika. Ostateczna ocena i decyzje należą do przełożonego.',
      aiSummaryFailed: 'Nie udało się przygotować podsumowania. Spróbuj ponownie.',
      aiSummaryGenerating: 'Przygotowujemy podsumowanie. Zajmie to chwilę.',
      aiSummaryRetry: 'Spróbuj ponownie',
      aiSummaryTakingLonger:
        'Przygotowanie trwa dłużej niż zwykle. Spróbuj ponownie lub wróć za kilka minut.',
      aiSummaryTitle: 'Podsumowanie pracownika wygenerowane przez AI',
      annualEvaluation: 'Wynik Oceny Rocznej',
      careerPath: 'Ścieżka kariery · Następny krok',
      company: 'Spółka',
      countryMobility: 'Mobilność krajowa',
      developmentContext: 'Obszary do rozwoju',
      education: 'Wykształcenie',
      englishLevel: 'Język angielski',
      evaluationType: 'Typ oceny',
      expatStatus: 'Status expat',
      feedback: {
        form: {
          cancelButton: 'Anuluj',
          description: 'Powód nieudzielenia feedbacku',
          label: 'Aktualizacja statusu feedbacku',
          sendNotProvidedButton: 'Nie udzielono',
          sendProvidedButton: 'Udzielono',
          submitNotFeedbackButton: 'Zapisz',
        },
        noReason: 'Nie podano powodu.',
        notProvided: 'Nie udzielono informacji zwrotnej',
        provided: 'Udzielono informacji zwrotnej',
      },
      finalGrade: 'Ocena końcowa',
      functionalArea: 'Obszar funkcjonalny',
      grade: 'Grade',
      internationalMobility: 'Mobilność międzynarodowa',
      latestProfileData: 'Na podstawie najnowszych danych profilu',
      leadershipPotential: 'Potencjał liderski',
      leavingRisk: 'Ryzyko odejścia',
      managementTrainee: 'Program Management Trainee',
      mdrResult: 'Wynik Przeglądu Potencjału MDR',
      no: 'Nie',
      noComment: 'Brak udzielonego komentarza.',
      noEvaluationData: 'Brak danych oceny rocznej.',
      noMdrData: 'Brak danych przeglądu MDR.',
      personalLevel: 'Poziom personalny',
      potential: 'Potencjał',
      profileDetails: 'Szczegóły profilu',
      profileSignals: 'Kluczowe mocne strony',
      provided: 'Udzielono',
      qualitativeGrade: 'Ocena jakościowa',
      quantitativeGrade: 'Ocena ilościowa',
      reviewComment: 'Komentarz do przeglądu',
      sopAnalysis: 'Analiza SOP',
      sopResult: 'Wynik SOP',
      yes: 'Tak',
    },
    employeeSupervisorsLabel: 'PRZEŁOŻENI PRACOWNIKA',
    fields: {
      department: 'DZIAŁ',
      hrBusinessPartner: 'HR BUSINESS PARTNER',
      position: 'STANOWISKO',
      region: 'REGION',
      sapNumber: 'NUMER SAP',
      tenureJmp: 'STAŻ PRACY W JMP',
      tenurePosition: 'STAŻ PRACY NA STANOWISKU',
    },
    roles: {
      employeeSelf: 'Pracownik',
      hrBusinessPartner: 'HR Business Partner',
      p1Manager: 'P1 Manager',
      p2Manager: 'P2 Manager',
      self: 'Ja',
    },
    supervisorsLabel: 'MOI PRZEŁOŻENI',
    title: 'Dane podstawowe',
  },
  common: {
    noData: 'Brak danych',
  },
  dashboard: {
    activities: {
      continue: 'Kontynuuj',
      empty: 'Brak aktywności rozwojowych',
      more: '+ {{count}} więcej aktywności',
      open: 'Otwórz',
      title: 'Aktywności rozwojowe',
    },
    currentSteps: {
      daysAgo: '({{count}} dni temu)',
      empty: 'Brak aktywnych zadań',
      moreTasks: '+ {{count}} więcej zadań',
      title: 'Aktualne zadania',
    },
    directionLabel: 'MÓJ KIERUNEK ROZWOJU',
    employeeDirectionLabel: 'KIERUNEK ROZWOJU PRACOWNIKA',
    emptyPlan: {
      action: 'Przejdź do planu',
      description: 'Utwórz plan rozwoju...',
      title: 'Brak planu rozwoju',
    },
    goToDevelopment: 'Przejdź do „Mój rozwój”',
    goToEmployeeDevelopment: 'Przejdź do „Rozwój pracownika”',
    noDirection: 'Brak przypisanego planu rozwoju',
    roleView: {
      activitiesInProgress: 'Aktywności w toku',
      completedSteps: '{{completed}} z {{total}} kroków ukończone',
      emptyPlan: {
        description: 'Ten pracownik nie rozpoczął jeszcze planu rozwoju.',
        title: 'Brak planu rozwoju',
      },
      giveFeedback: 'Udziel informacji zwrotnej',
      goToPlan: 'Przejdź do planu',
      noOverdue: 'Brak zaległych kroków',
      overdueDays: '{{count}} dni po terminie',
      overdueSteps: 'Krok zaległy',
      planDirection: 'Kierunek rozwoju: {{direction}}',
      planProgress: 'Postęp planu',
    },
    stats: {
      activitiesInProgress: 'Aktywności w toku',
      overdueTasks: 'Zadania zaległe',
      stepsCompleted: 'Kroki ukończone',
    },
    title: 'Panel Rozwoju',
  },
  development: {
    aiAssistant: {
      aiNotice: {
        intro:
          'jAIn to narzędzie oparte na sztucznej inteligencji, które wspiera Twoją naukę, rozwój i planowanie kariery. Im więcej informacji o sobie podasz, tym lepiej dopasowane będą rekomendacje.',
        points: {
          errors: 'Odpowiedzi AI mogą być błędne lub niepełne.',
          otherPeopleData:
            'Nie podawaj danych innych osób, chyba że wymagają tego Twoje obowiązki służbowe i masz odpowiednie uprawnienia.',
          security:
            'Korzystaj z narzędzia zgodnie z zasadami ochrony danych i bezpieczeństwa informacji.',
        },
        rememberLabel: 'Pamiętaj:',
      },
      casualGreeting: 'Zadaj mi pytania o swoje umiejętności lub wybierz z najczęstszych poniżej.',
      casualMode: 'Luźny czat',
      casualModeHeader: 'TRYB: LUŹNY CZAT',
      casualSuggestions: {
        conflictResolution: 'Rozwiązywanie Konfliktów',
        feedback: 'Feedback',
        keyCompetencies: 'Kluczowe Kompetencje',
        matchProjects: 'Dopasuj Projekty',
        taskDelegation: 'Delegowanie Zadań',
      },
      employeeModeHeader:
        'TRYB: ROZMOWA O PRACOWNIKU – DOWIEDZ SIĘ WIĘCEJ O SWOIM PRACOWNIKU I JEGO UMIEJĘTNOŚCIACH',
      noActivePlan: 'Brak aktywnego planu',
      noActivePlanDescription: 'Asystent będzie dostępny po utworzeniu aktywnego planu rozwoju.',
      planGreeting: 'Cześć, napisz do mnie, aby wspólnie zbudować Twój plan rozwoju.',
      planMode: 'Praca z planem',
      planModeHeader: 'TRYB: PRACA Z PLANEM ROZWOJOWYM',
      planSuggestions: {
        addStep: 'Dodaj krok',
        nextStep: 'Następny krok',
        summarize: 'Podsumuj postępy',
        update: 'Aktualizuj plan',
      },
      selectMode: 'Wybierz tryb pracy asystenta',
      title: 'Asystent Rozwoju AI',
    },
    campaignInactive: {
      description:
        'Nie jesteś obecnie objęty żadnym cyklem rozwojowym, więc nie możesz utworzyć planu. Tworzenie planu odblokuje się, gdy zostaniesz objęty kolejnym cyklem.',
      employeeDescription:
        'Pracownik nie jest objęty żadnym cyklem rozwojowym, więc nie można utworzyć dla niego planu. Tworzenie planu odblokuje się, gdy pracownik zostanie objęty kolejnym cyklem.',
      employeeTitle: 'Pracownik nie jest objęty cyklem rozwojowym',
      title: 'Nie jesteś objęty cyklem rozwojowym',
    },
    certificationResults: {
      description: 'Na podstawie wyników certyfikacji możesz dodać kroki do planu.',
      link: 'Sprawdź swoje wyniki',
    },
    employeeTitle: 'Rozwój pracownika',
    emptyPlan: {
      chatReadyDescription:
        'Przestrzeń planu jest gotowa. Pracuj z asystentem AI nad przygotowaniem kroków rozwojowych.',
      create: 'Określ kierunek rozwoju',
      creating: 'Tworzenie...',
      description:
        'Nie masz jeszcze utworzonego planu rozwoju. Utwórz go - określ kierunek i rozpocznij nad nim pracę z pomocą asystenta AI.',
      direction: 'KIERUNEK ROZWOJU',
      directionFromCampaign:
        'Kierunek został ustalony przez administratora w kampanii rozwojowej i nie można go zmienić.',
      initialize: 'Rozpocznij plan',
      noPermission: 'Nie masz uprawnień do utworzenia planu rozwoju dla tego profilu.',
      submit: 'Rozpocznij',
      supervisorDescription:
        'Ten pracownik nie ma jeszcze planu rozwoju. Określ kierunek i datę początku, aby zainicjować plan.',
      title: 'Brak planu rozwoju',
      validFrom: 'Ważny od',
      validTo: 'Ważny do',
    },
    goalBar: {
      approver: 'Zatwierdzający: {{name}} (P1)',
      cancel: 'Anuluj',
      cycle: 'Cykl:',
      directionFromCampaign:
        'Kierunek został ustalony przez administratora w kampanii rozwojowej i nie można go zmienić.',
      directionLabel: 'Kierunek planu rozwojowego:',
      save: 'Zapisz',
      statusChange: {
        approval: {
          approve: 'Zatwierdź plan',
          awaitingMessage: 'Pracownik oczekuje na akceptację aktualizacji w planie.',
          cancel: 'Anuluj',
          commentLabel: 'Komentarz dla pracownika',
          commentPlaceholder: 'Wpisz, co wymaga poprawy w tym planie...',
          requestChanges: 'Poproś o zmiany',
          submitRequest: 'Wyślij prośbę o zmiany',
        },
        cancel: 'Anuluj',
        comment: 'Komentarz',
        completeBlocked: 'Najpierw ukończ wszystkie kamienie milowe',
        confirm: 'Potwierdź',
        confirmMessage: 'Czy na pewno chcesz wykonać akcję: {{action}}?',
        confirmReject: 'Potwierdź odrzucenie',
        confirmTitle: 'Nieodwracalna akcja',
        confirmWarning:
          'Po potwierdzeniu cykl stanie się nieaktywny i trafi do cykli historycznych — nie będzie można go edytować ani cofnąć.',
        submitBlocked: 'Wymagane są co najmniej 2 kroki',
      },
    },
    history: {
      by: 'Przez:',
      changeTypes: {
        [DevelopmentPathChangeTypeDto.CycleStateChange]: 'Zmieniono status cyklu',
        [DevelopmentPathChangeTypeDto.StepAdded]: 'Dodano krok \u201e{{milestone}}\u201d',
        [DevelopmentPathChangeTypeDto.StepDeleted]: 'Usunięto krok \u201e{{milestone}}\u201d',
        [DevelopmentPathChangeTypeDto.StepMarkedDone]:
          'Oznaczono jako ukończony krok \u201e{{milestone}}\u201d',
        [DevelopmentPathChangeTypeDto.StepMarkedUndone]:
          'Cofnięto ukończenie kroku \u201e{{milestone}}\u201d',
        [DevelopmentPathChangeTypeDto.StepUpdated]: 'Zmieniono krok \u201e{{milestone}}\u201d',
      },
      cycleState: {
        initial: 'Utworzono szkic planu',
        transition: 'Status planu: {{from}} \u2192 {{to}}',
      },
      detailSet: '{{field}}: {{to}}',
      detailUpdated: '{{field}}: {{from}} \u2192 {{to}}',
      fields: {
        [DevelopmentPathStepFieldDto.Actions]: 'działania',
        [DevelopmentPathStepFieldDto.Deadline]: 'termin',
        [DevelopmentPathStepFieldDto.Milestone]: 'nazwa',
        [DevelopmentPathStepFieldDto.StartDate]: 'start',
      },
      sources: {
        [DevelopmentPathChangeSourceDto.AiChat]: 'przez czat AI',
        [DevelopmentPathChangeSourceDto.Manual]: 'ręcznie',
        [DevelopmentPathChangeSourceDto.System]: 'automatycznie',
      },
      title: 'Historia',
      unnamedStep: 'krok bez nazwy',
    },
    historyDialog: {
      button: 'Historia planów',
      close: 'Zamknij',
      empty: 'Brak historycznych planów rozwojowych.',
      loadingPreview: 'Ładowanie planu historycznego...',
      preview: 'Podgląd',
      restore: {
        blocked: {
          ACTIVE_PLAN_EXISTS: 'Zakończ aktywny plan rozwoju, aby przywrócić ten historyczny.',
          CAMPAIGN_MISMATCH: 'Plan pochodzi z innego cyklu rozwojowego niż obowiązujący teraz.',
        },
        button: 'Przywróć',
        error: 'Nie udało się przywrócić planu.',
        success: 'Plan został przywrócony.',
      },
      stepsCount: '{{completed}}/{{total}} kroków',
      title: 'Historyczne plany rozwojowe',
    },
    milestone: {
      completeBlockedUntilRealization:
        'Ustaw status planu na „W realizacji”, aby oznaczać kroki jako ukończone',
      completedOn: 'Ukończono: {{date}}',
      delete: 'Usuń krok',
      edit: 'Edytuj krok',
      markComplete: 'Oznacz jako ukończony',
      overdue: 'Przeterminowane ({{days}} dni)',
      statusDone: 'Zakończony',
      statusInProgress: 'W toku',
      statusPlanned: 'Planowany',
      step: 'Krok {{index}}:',
      undoComplete: 'Cofnij ukończenie',
      viewDetails: 'Pokaż szczegóły',
    },
    onboarding: {
      ai: {
        description:
          'Pozwól asystentowi AI tworzyć kroki razem z Tobą albo dodaj je samodzielnie. W każdej chwili możesz to zmienić.',
        manualAction: 'Zrobię to samodzielnie',
        primaryAction: 'Praca z planem',
        title: 'Jak chcesz dodać kroki?',
      },
      chatInput: {
        description:
          'Napisz asystentowi swój cel lub wybierz podpowiedź. Zamieni on rozmowę w gotowe kroki.',
        primaryAction: 'Rozumiem',
        title: 'Po prostu zacznij rozmowę',
      },
      direction: {
        description:
          'Zanim dodasz kroki, podaj, nad czym chcesz pracować, i wybierz datę, od której plan zaczyna obowiązywać.',
        title: 'Zacznij od celu',
      },
      directionForm: {
        description:
          'Wpisz, w jakim kierunku będziesz się rozwijać, i wybierz datę początku. Potem przygotujemy Twój plan.',
        primaryAction: 'Wypełnij formularz',
        title: 'Uzupełnij cel i datę',
      },
      landing: {
        description:
          'Przeprowadzimy Cię przez to krok po kroku. Najpierw ustalisz cel i daty — potem dodasz to, nad czym chcesz pracować, z pomocą AI lub samodzielnie.',
        title: 'Stwórzmy Twój plan rozwoju',
      },
      manual: {
        description:
          'Użyj przycisku „Dodaj nowy krok”, aby ustawić kamień milowy, jego daty i konkretne działania — bez asystenta.',
        title: 'Dodaj kroki samodzielnie',
      },
      manualForm: {
        description:
          'Nadaj nazwę kamieniowi milowemu, ustaw daty i wypisz działania, które Cię do niego przybliżą.',
        primaryAction: 'Rozumiem',
        title: 'Dodaj pierwszy krok',
      },
      progress: '{{current}} z {{total}}',
      viewMode: {
        description:
          'Widok Plan + Czat pokazuje jedno i drugie obok siebie. Możesz też skupić się tylko na planie albo tylko na rozmowie.',
        primaryAction: 'Pokaż opcje',
        title: 'Wybierz, jak chcesz pracować',
      },
    },
    pendingSupervisorInitiation: {
      description:
        'Twój przełożony został poproszony o zainicjowanie Twojego planu rozwoju (ustalenie kierunku i dat). Gdy to zrobi, plan pojawi się tutaj. Jeśli nie zrobi tego w ciągu 7 dni, będziesz mógł utworzyć plan samodzielnie.',
      title: 'Przełożony inicjuje Twój plan rozwoju',
    },
    plan: {
      addStep: 'Dodaj nowy krok',
      addStepForm: {
        actionPlaceholder: 'Opisz działanie…',
        actions: 'DZIAŁANIA',
        addAction: 'Dodaj działanie',
        cancel: 'Anuluj',
        deadline: 'Termin',
        deadlineWithinCycle: 'Termin kroku nie może wykraczać poza koniec cyklu ({{to}}).',
        editTitle: 'Edytuj krok',
        maxActions: 'Krok może mieć maksymalnie {{max}} działań.',
        milestone: 'Kamień milowy',
        save: 'Zapisz krok',
        saveError: 'Nie udało się zapisać kroku.',
        startDate: 'Data rozpoczęcia',
        title: 'Nowy krok',
      },
      completedSection: 'UKOŃCZONE KROKI',
      confirmDelete: 'Czy na pewno chcesz usunąć ten krok planu?',
      deleteDialog: {
        cancel: 'Anuluj',
        confirm: 'Usuń krok',
        title: 'Usuń krok planu',
      },
      draftLabel: 'Szkic',
      emptyStepsDescription: 'Dodaj pierwszy krok, aby rozpocząć śledzenie postępu planu.',
      inProgressSection: 'W REALIZACJI I ZAPLANOWANE',
      progress: {
        archived: 'Plan zarchiwizowany ({{completed}} z {{total}} kroków ukończonych)',
        archivedEmpty: 'Plan zarchiwizowany (bez kroków)',
        cancelled: 'Plan anulowany ({{completed}} z {{total}} kroków ukończonych)',
        cancelledEmpty: 'Plan anulowany (bez kroków)',
        completed: 'Plan ukończony ({{completed}} z {{total}} kroków)',
        completedEmpty: 'Plan ukończony (bez kroków)',
        draft: 'Szkic ({{steps}})',
        draftEmpty: 'Szkic (brak kroków)',
        draftHint: 'Plan wymaga minimum {{min}} kroków, aby wysłać go do akceptacji.',
        noPlan: 'Brak planu rozwojowego',
        realization: 'W realizacji ({{completed}} z {{total}} kroków)',
        realizationEmpty: 'Rozpocznij pracę nad planem',
        rejected: 'Zwrócony do poprawy ({{steps}})',
        rejectedHint: 'Popraw plan i wyślij go ponownie do akceptacji.',
        stepsCount_few: '{{count}} kroki',
        stepsCount_many: '{{count}} kroków',
        stepsCount_one: '{{count}} krok',
        stepsCount_other: '{{count}} kroków',
      },
      progressLabel: 'POSTĘP PLANU',
      rejectionComment: 'Komentarz przełożonego:',
      reorder: 'Zmień kolejność',
      startWorking: 'Rozpocznij pracę nad planem',
      startWorkingCta: 'Porozmawiaj z Asystentem Rozwoju AI, aby dodać kroki rozwojowe',
    },
    planBlockedDcFeedback: {
      description:
        'Tworzenie planu otworzy się, gdy zostanie odnotowane Twoje spotkanie feedbackowe po sesji Development Center. Umówi je przełożony lub HR.',
      employeeDescription:
        'Tworzenie planu otworzy się, gdy zostanie odnotowane spotkanie feedbackowe pracownika po sesji Development Center. Umów spotkanie lub skontaktuj się z HR.',
      employeeTitle: 'Pracownik czeka na spotkanie feedbackowe po Development Center',
      title: 'Czekasz na spotkanie feedbackowe po Development Center',
    },
    preview: {
      error: {
        description: 'Spróbuj ponownie lub wróć do aktualnego planu.',
        retry: 'Spróbuj ponownie',
        title: 'Nie udało się otworzyć planu',
      },
      returnToActive: 'Wróć do aktualnego planu',
      subtitle: '{{direction}} ({{validFrom}} - {{validTo}})',
      title: 'Tryb podglądu: Plan historyczny',
    },
    stepsOnboarding: {
      ai: {
        description:
          'Pozwól asystentowi AI tworzyć kroki razem z Tobą albo dodaj je samodzielnie. W każdej chwili możesz to zmienić.',
        manualAction: 'Zrobię to samodzielnie',
        primaryAction: 'Praca z planem',
        title: 'Jak chcesz dodać kroki?',
      },
      chatInput: {
        description:
          'Napisz asystentowi swój cel lub wybierz podpowiedź. Zamieni rozmowę w gotowe kroki.',
        primaryAction: 'Rozumiem',
        title: 'Po prostu zacznij rozmowę',
      },
      landing: {
        description:
          'Twój przełożony ustalił już kierunek i daty. Kliknij tutaj, aby dodać kroki, które doprowadzą Cię do celu.',
        title: 'Twój plan czeka na kroki',
      },
      manual: {
        description:
          'Użyj przycisku „Dodaj nowy krok”, aby ustawić kamień milowy, jego daty i konkretne działania — bez asystenta.',
        title: 'Dodaj kroki samodzielnie',
      },
      manualForm: {
        description:
          'Nadaj nazwę kamieniowi milowemu, ustaw daty i wypisz działania, które Cię do niego przybliżą.',
        primaryAction: 'Rozumiem',
        title: 'Dodaj pierwszy krok',
      },
      progress: '{{current}} z {{total}}',
      viewMode: {
        description:
          'Zobacz plan i czat obok siebie albo skup się na jednym — przełączysz się w każdej chwili.',
        primaryAction: 'Pokaż opcje',
        title: 'Plan gotowy — czas na kroki',
      },
    },
    supervisorOnboarding: {
      direction: {
        description:
          'Ten pracownik czeka na zainicjowanie planu rozwoju. Kliknij tutaj, aby określić kierunek i datę początku.',
        title: 'Zainicjuj plan pracownika',
      },
      directionForm: {
        description:
          'Wpisz kierunek rozwoju pracownika i wybierz datę początku. Resztę planu uzupełni już sam pracownik.',
        primaryAction: 'Wypełnij formularz',
        title: 'Uzupełnij cel i datę',
      },
      progress: '{{current}} z {{total}}',
    },
    tabs: {
      activities: 'Moje Aktywności',
      employeeActivities: 'Aktywności',
      plan: 'Plan Rozwoju i Asystent AI',
    },
    title: 'Mój rozwój',
    viewMode: {
      chatOnly: 'Widok samego czatu',
      label: 'ZMIANA WIDOKU',
      planOnly: 'Widok samego planu',
      split: 'Widok domyślny',
    },
  },
  questMap: {
    currentStep: 'Aktualny krok',
    deadline: 'Termin: {{date}}',
    step: 'Krok {{number}}',
  },
  sidebar: {
    backToStart: 'Wróć na Start',
    collapseAriaLabel: 'Zwiń menu profilu',
    nav: {
      basicData: 'Dane podstawowe',
      dashboard: 'Panel Rozwoju',
      development: 'Mój rozwój',
      employeeDevelopment: 'Rozwój pracownika',
      tasks: 'Moje zadania',
    },
    roleSwitcher: {
      ariaLabel: 'Przełącznik roli profilu',
      label: 'Przeglądasz jako',
    },
    subNav: {
      activities: 'Moje Aktywności',
      employeeActivities: 'Aktywności',
      planAndAssistant: 'Plan Rozwoju i Asystent AI',
    },
  },
  tasks: {
    actions: {
      cancel: 'Anuluj',
      done: 'Zakończ',
      start: 'Rozpocznij',
    },
    completed: 'Zakończone',
    createdAt: 'Utworzono: {{date}}',
    daysAgo: '({{count}} dni temu)',
    deadline: 'Termin: {{date}}',
    detailsDialog: {
      aboutLabel: 'Czego dotyczy',
      autoCloseIntro: 'To zadanie zamknie się automatycznie, gdy:',
      close: 'Zamknij',
      goToPlan: 'Przejdź do planu rozwojowego',
      reason: {
        DEVELOPMENT_PLAN_INITIATION_REQUIRED:
          'utworzysz plan rozwojowy temu podwładnemu (masz na to 7 dni — potem pracownik utworzy go sam)',
        DEVELOPMENT_PLAN_REQUIRED: 'utworzysz i złożysz plan rozwojowy do akceptacji',
        DEVELOPMENT_PLAN_REVIEW_REQUIRED: 'zaakceptujesz lub odrzucisz plan rozwojowy podwładnego',
        DEVELOPMENT_STEP_IN_PROGRESS: 'oznaczysz ten krok planu rozwojowego jako ukończony',
        DEVELOPMENT_STEP_OVERDUE: 'oznaczysz ten zaległy krok jako ukończony',
        MANUAL: 'wykonasz wymaganą akcję',
      },
      start: 'Rozpocznij',
      title: 'Szczegóły zadania',
    },
    empty: 'Brak dostępnych zadań',
    filters: {
      active: 'W toku',
      all: 'Wszystkie',
      done: 'Zakończone',
      overdue: 'Przeterminowane',
    },
    openForm: 'Otwórz formularz',
    process: '• Proces oceny',
    resourceType: {
      [ResourceTypeDto.App]: 'Aplikacja',
      [ResourceTypeDto.DevelopmentPath]: 'Ścieżka rozwoju',
      [ResourceTypeDto.Employee]: 'Pracownik',
      [ResourceTypeDto.Survey]: 'Ankieta',
    },
    showing: 'Wyświetlono {{visible}} z {{total}}',
    showMore: 'Pokaż więcej',
    start: 'Rozpocznij',
    status: {
      overdue: 'Przeterminowane',
      [TaskStatusDto.Cancelled]: 'Anulowane',
      [TaskStatusDto.Done]: 'Zakończone',
      [TaskStatusDto.InProgress]: 'W toku',
      [TaskStatusDto.Open]: 'Nowe',
    },
    title: 'Moje zadania',
  },
};
